var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaysetLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#274828"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.92845 3.5C8.07679 3.5 7.37871 3.80716 6.90401 4.49127V3.63962H5.10297H4V5.23124H5.10297V12.9799H6.90401V9.89442C7.37871 10.6065 8.06283 10.8997 8.92845 10.8997C11.0646 10.8997 12 9.22426 12 7.19983C12 5.17539 11.0646 3.5 8.92845 3.5ZM8.55148 9.23822C7.40663 9.23822 6.90401 8.60995 6.90401 7.18586C6.90401 5.77574 7.40663 5.14747 8.55148 5.14747C9.69633 5.14747 10.199 5.77574 10.199 7.18586C10.199 8.62391 9.69633 9.23822 8.55148 9.23822Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaysetLogo);
export default __webpack_public_path__ + "static/media/payset-logo.fd047f52.svg";
export { ForwardRef as ReactComponent };